import React from 'react';
import {
  CTA_TYPES,
  trackCtaClicked,
} from '@zola-helpers/client/dist/es/tracking/ctaEvents/ctaEvents';
import magicAdTileDesktop from 'assets/images/magic/MagicAdTileDesktop.png';
import magicAdTileMobile from 'assets/images/magic/MagicAdTileMobile.png';

import { TileContainer, Image, Title, MagicButton, MagicLink } from './MagicAdTile.style';

interface MagicAdTileProps {
  cardType: string;
}

export const MagicAdTile: React.FC<MagicAdTileProps> = ({ cardType }) => {
  const handleMagicAdCTA = () =>
    trackCtaClicked({
      business_unit: 'INVITATIONS',
      cta_type: CTA_TYPES.BUTTON,
      cta: 'DISNEY_MAGIC_MOMENTS',
      location: 'PAPER_PLP',
      section: cardType,
      position: 0,
      cta_id: 'DISNEY_MAGIC_AD',
    });

  return (
    <TileContainer>
      <Title>Enchant your guests</Title>
      <Image>
        <source srcSet={magicAdTileDesktop} media="(min-width: 992px)" />
        <img src={magicAdTileMobile} alt="Magic cards" />
      </Image>
      <MagicButton
        component="a"
        href="/wedding-planning/disney"
        onClick={handleMagicAdCTA}
        textTransform={false}
      >
        Shop Disney Magic Moments
      </MagicButton>
      <MagicLink variant="tertiary" href="/wedding-planning/disney" onClick={handleMagicAdCTA}>
        Shop Disney Magic Moments
      </MagicLink>
    </TileContainer>
  );
};
